package com.anjuros.website.templates.template5.modules

import com.anjuros.website.templates.template5.util.ResKey

enum class Template5HeaderItem(

    val text: ResKey,
    val id: String,
    val path: String

) {



    PRODUCTS(
        text = ResKey.TEMPLATE5_HEADER_PRODUCTS,
        id = "products",
        path = "#products",
    ),

    ABOUT(
        text = ResKey.TEMPLATE5_HEADER_ABOUT,
        id ="about",
        path ="#about",
    ),

    REVIEWS(
        text = ResKey.TEMPLATE5_HEADER_REVIEWS,
        id ="reviews",
        path ="#reviews",
    ),

    FAQ(
        text =ResKey.TEMPLATE5_HEADER_FAQ,
        id ="faq",
        path ="#faq",
    ),

    CONTACT(
        text = ResKey.TEMPLATE5_HEADER_CONTACT,
        id ="contact",
        path ="#contact",
    )

}